import React from "react";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Plus, Trash2 } from "lucide-react";

const ic = "text-[15px] rounded-lg border-[#1C4358]/20 focus-visible:ring-0";

export const StringListEditor = ({ label, items = [], onChange, readOnly, testid, placeholder }) => (
  <div className="space-y-2" data-testid={testid}>
    {label && <Label className="text-[13px] font-semibold text-[#1C4358]">{label}</Label>}
    {items.map((v, i) => (
      <div key={i} className="flex gap-2">
        <Input className={ic} value={v} placeholder={placeholder} disabled={readOnly}
          onChange={(e) => { const n = [...items]; n[i] = e.target.value; onChange(n); }} />
        {!readOnly && <Button type="button" variant="ghost" size="icon" onClick={() => onChange(items.filter((_, x) => x !== i))} className="text-[#9C1E22] shrink-0"><Trash2 size={15} /></Button>}
      </div>
    ))}
    {!readOnly && <Button type="button" variant="outline" size="sm" onClick={() => onChange([...items, ""])} className="gap-1 border-[#D6E0E7] text-[#1C4358]"><Plus size={14} /> Add</Button>}
  </div>
);

export const ObjectListEditor = ({ label, items = [], fields, onChange, readOnly, testid }) => (
  <div className="space-y-3" data-testid={testid}>
    {label && <Label className="text-[13px] font-semibold text-[#1C4358]">{label}</Label>}
    {items.map((it, i) => (
      <Card key={i} className="p-3 border-[#E6EDF2] space-y-2">
        {fields.map((f) => (
          f.textarea ? (
            <Textarea key={f.key} rows={2} className={ic} placeholder={f.label} disabled={readOnly}
              value={it[f.key] || ""} onChange={(e) => { const n = [...items]; n[i] = { ...n[i], [f.key]: e.target.value }; onChange(n); }} />
          ) : (
            <Input key={f.key} className={ic} placeholder={f.label} disabled={readOnly}
              value={it[f.key] || ""} onChange={(e) => { const n = [...items]; n[i] = { ...n[i], [f.key]: e.target.value }; onChange(n); }} />
          )
        ))}
        {!readOnly && <Button type="button" variant="ghost" size="sm" onClick={() => onChange(items.filter((_, x) => x !== i))} className="text-[#9C1E22] gap-1"><Trash2 size={14} /> Remove</Button>}
      </Card>
    ))}
    {!readOnly && <Button type="button" variant="outline" size="sm" onClick={() => onChange([...items, {}])} className="gap-1 border-[#D6E0E7] text-[#1C4358]"><Plus size={14} /> Add</Button>}
  </div>
);
